import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  'common--cmp--box-spinner': {
    display: 'grid',
    minHeight: '75px',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      animation: 'spin-animation 1.0s infinite steps(8, end)',
    },
  },
  '@keyframes spin-animation': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(359deg)',
    },
  },
}));
